/* ==========================================================================
   HLTH+ Quiz Config — assets/hlth-quiz-config.js
   The ONLY file with store-specific IDs. Everything here is a clearly
   labelled placeholder — nothing is required for the quiz to run, because
   product/variant/selling-plan data is read live from the products picked in
   the theme editor (see sections/hlth-formula-quiz.liquid).

   ⚠️ Do not put private API keys of any kind in this file. It is served
   publicly to every visitor. Klaviyo needs no key here — the Klaviyo Shopify
   app's embed already loads klaviyo.js with your public Site ID.
   ========================================================================== */

window.HLTH_QUIZ_CONFIG = {

  /* -------------------------------------------------------------------------
     SELLING_PLAN_MAP (optional override)
     By default the quiz picks a selling plan by matching the plan's NAME on
     the matched product (e.g. a plan named "Delivery every 4 weeks" matches
     the "4-week" frequency). If your plan names don't contain the week count,
     paste the exact selling plan IDs here instead.

     Where to find them: Shopify admin → Products → [your product] →
     Purchase options → open the selling plan group. Or run this in the
     browser console on the product page:
       fetch('/products/YOUR-HANDLE.js').then(r => r.json())
         .then(p => console.log(p.selling_plan_groups))
     Use the numeric `id` of each selling plan (not the group id).
     ---------------------------------------------------------------------- */
  SELLING_PLAN_MAP: {
    '4-week': 'REPLACE_WITH_4_WEEK_SELLING_PLAN_ID',
    '6-week': 'REPLACE_WITH_6_WEEK_SELLING_PLAN_ID',
    '8-week': 'REPLACE_WITH_8_WEEK_SELLING_PLAN_ID'
  },

  /* Where to send the visitor after "Add My Match to Cart" succeeds. */
  AFTER_ADD_URL: '/checkout'
};
